import styled from 'styled-components';
import theme from '../../styles/defaultTheme';

export const StyledAccordion = styled.div`
  background: transparent;
  border-radius: 16px;
`;

export const StyledTitle = styled.h2`
  font-size: ${theme.font.size20};
  margin-bottom: 0;
  font-weight: bold;
`;

export const Sep = styled.div`
  height: 1px;
  opacity: 0.4;
  border-radius: 2px; 
  margin: 0 0 32px 0;
`;

export const StyledAccordionSummary = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
  color: ${(props) => props.theme.orangeLink};
  cursor: ${({ hasCollapse }) => (hasCollapse ? 'pointer' : 'default')};
  position: relative;
`;

export const StyledAccordionDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  &.closed {
    max-height: 0px;
    overflow: hidden;
    display: none;
  }

  &.open {
    max-height: 100%;
  }
`;